import { render, staticRenderFns } from "./topCommon.vue?vue&type=template&id=52e9751a&scoped=true"
import script from "./topCommon.vue?vue&type=script&lang=js"
export * from "./topCommon.vue?vue&type=script&lang=js"
import style0 from "./topCommon.vue?vue&type=style&index=0&id=52e9751a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e9751a",
  null
  
)

export default component.exports